import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30ac4caa")

_pushScopeId("data-v-30ac4caa")
const _hoisted_1 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_2 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Message = _resolveComponent("Message")
  const _component_WorkspaceSchedulationSchedulationsTable = _resolveComponent("WorkspaceSchedulationSchedulationsTable")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.jobs,
    id: "jobs-table",
    class: "p-datatable-sm kn-table",
    expandedRows: _ctx.expandedRows,
    "onUpdate:expandedRows": _cache[3] || (_cache[3] = ($event: any) => (_ctx.expandedRows = $event)),
    dataKey: "jobName",
    filters: _ctx.filters,
    "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
    globalFilterFields: _ctx.workspaceSchedulationTableDescriptor.globalFilterFields,
    paginator: true,
    rows: 20,
    responsiveLayout: "stack",
    breakpoint: "960px"
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            modelValue: _ctx.filters['global'].value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
            type: "text",
            placeholder: _ctx.$t('common.search'),
            "data-test": "search-input"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    empty: _withId(() => [
      _createVNode(_component_Message, {
        class: "p-m-2",
        severity: "info",
        closable: false,
        style: _ctx.workspaceSchedulationTableDescriptor.styles.message
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    expansion: _withId((slotProps) => [
      _createVNode(_component_WorkspaceSchedulationSchedulationsTable, {
        class: "p-m-4",
        triggers: slotProps.data.triggers,
        index: slotProps.index,
        propSelectedSchedulations: _ctx.selectedSchedulations,
        onRunSchedulationClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('runSchedulationClick', $event))),
        onSelectedSchedulations: _ctx.setSelectedSchedulations
      }, null, 8, ["triggers", "index", "propSelectedSchedulations", "onSelectedSchedulations"])
    ]),
    default: _withId(() => [
      _createVNode(_component_Column, {
        expander: true,
        headerStyle: _ctx.workspaceSchedulationTableDescriptor.expanderHeaderStyle
      }, null, 8, ["headerStyle"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workspaceSchedulationTableDescriptor.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          class: "kn-truncated",
          field: col.field,
          header: _ctx.$t(col.header),
          key: col.field,
          sortable: true
        }, null, 8, ["field", "header"]))
      }), 128)),
      _createVNode(_component_Column, {
        style: _ctx.workspaceSchedulationTableDescriptor.iconColumn.style
      }, {
        body: _withId((slotProps) => [
          (_ctx.canSeeScheduledExecutions)
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "fa fa-eye",
                class: "p-button-link",
                onClick: _withModifiers(($event: any) => (_ctx.viewRanSchedulations(slotProps.data)), ["stop"])
              }, null, 8, ["onClick"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('workspace.schedulation.ranSchedulations'),
                  void 0,
                  { left: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["value", "expandedRows", "filters", "globalFilterFields"]))
})